/**
 * `core/barba/barbaEventObserver.js`
 *  - イベントのオンオフ管理
 *
 * 使用方法:
 *  - import {barbaEventObserver} from "./core/barba/utils/barbaEventObserver.js";
 */


/* =============================================================
 * イベントの重複登録を避けるため、ページ遷移のタイミングで登録されたイベントを削除する
 * SPA仕様のWEBサイトで主に使用する
 * ========================================================== */
export const barbaEventObserver = {
  handlers: [],   // イベントリスナーの管理

  /**
   * イベントを登録
   * @param {Array} targets - [対象要素, イベント名, コールバック関数, オプション]
   */
  observeEvents: function(targets) {
    if (!targets || !Array.isArray(targets) || targets.length === 0) return;
    this.handlers.push(targets);
  },


  /**
   * すべてのイベントリスナーを削除
   */
  clearEvents: function() {
    const _self = this;

    function loop(i) {
      return new Promise(function(resolve) {
        const events = _self.handlers[i];

        if (!events || !Array.isArray(events)) return resolve(i++); // 安全チェック

        // handlers[i] 内のイベントを削除
        for (let j = events.length - 1; j >= 0; j--) {
          const [element, eventType, handler, options] = events[j];

          if (!element || !eventType || !handler) continue;

          /*
          bindしたメソッドを考慮する場合は以下を検討する
          // **クラスメソッドの場合の処理**
          if (handler instanceof Function) {
            // `bind()` されたメソッドも考慮
            const methodName = handler.name; // メソッド名を取得

            if (methodName.includes("bound ")) {
              console.warn(`⛔ Skipping bound method: ${methodName}`);
              continue; // `bind(this)` されたメソッドは削除対象外（バグ防止）
            }
          }
          */

          // **通常のイベントリスナーを削除**
          try {
            element.removeEventListener(eventType, handler, options || false);
          } catch (error) {
            console.error("⚠️ Failed to remove event listener:", eventType, handler, error);
          }
        }

        // handlers[i] を削除
        _self.handlers.splice(i, 1);
        resolve(i++);
      }).then(function(count) {
        if (count >= _self.handlers.length) return;
        loop(count);
      });
    }

    if (_self.handlers.length > 0) {
      loop(0);
    }
  },
};

import { barbaThreeSceneObserver } from "./barbaThreeSceneObserver.js";

// Three.js シーンインスタンスを破棄
barbaThreeSceneObserver.destroyScene();